import { Select } from "@primer/react";
import { apiClient } from "../apiClient";
import { IDotXetChungChiThamSoXet } from "../../model/response/xet-chung-chi/IDotXetChungChiThamSoXet";

const DOT_XET_CHUNG_CHI_THAM_SO_XET_API = "dot-xet-chung-chi-tham-so-xet";
export const dotXetChungChiThamSoXetApi = {
    SelectByDotXet: (id_dot_xet: number) => apiClient.get(`${DOT_XET_CHUNG_CHI_THAM_SO_XET_API}/da-them/${id_dot_xet}`),
    SelectNotExistsDotXet: (id_dot_xet: number) => apiClient.get(`${DOT_XET_CHUNG_CHI_THAM_SO_XET_API}/chua-them/${id_dot_xet}`),
    Insert: (data: IDotXetChungChiThamSoXet) => apiClient.post(`${DOT_XET_CHUNG_CHI_THAM_SO_XET_API}`, data),
    Update: (id: number, data: IDotXetChungChiThamSoXet) => apiClient.put(`${DOT_XET_CHUNG_CHI_THAM_SO_XET_API}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${DOT_XET_CHUNG_CHI_THAM_SO_XET_API}/${id}`),
}